/**
 * External Tools Configuration — SSO Launcher
 * URLs de las herramientas externas por ambiente.
 * Usado exclusivamente por LaunchPage (componente de prueba SSO).
 */

export interface ExternalTool {
  id: string;
  name: string;
  description: string;
  ssoPath: string; // Ruta que recibe el auto-login
  urls: {
    local: string;
    qa: string;
    prod: string;
  };
}

export const EXTERNAL_TOOLS: ExternalTool[] = [
  {
    id: 'inventory',
    name: 'Inventory Portal',
    description: 'Gestión de inventario de propiedades',
    ssoPath: '/sso',
    urls: {
      local: 'http://localhost:3002',
      qa: 'https://inventory.llavero.co',
      prod: 'https://inventory.habi.co',
    },
  },
  {
    id: 'portal-pricing',
    name: 'Portal Pricing',
    description: 'Valuación y precios de propiedades',
    ssoPath: '/sso',
    urls: {
      local: 'http://localhost:3001',
      qa: 'https://pricing.llavero.co',
      prod: 'https://pricing.habi.co',
    },
  },
];

/**
 * Detecta el ambiente actual según el hostname
 */
export const getCurrentEnvironment = (): 'local' | 'qa' | 'prod' => {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'local';
  if (hostname.includes('llavero.co')) return 'qa';
  return 'prod';
};

/**
 * Retorna la URL base de una herramienta según el ambiente actual
 */
export const getToolUrl = (tool: ExternalTool): string => {
  const env = getCurrentEnvironment();
  return tool.urls[env];
};

